export enum GlobalFirestopRoutes {
  BASE = 'firestops',
  BUILDER = 'builder'
}
